<template>
  <el-dialog
    :title="$t('stockout.确认到货日期')"
    :visible.sync="dialogModal.visible"
    :close-on-click-modal="false"
    :before-close="initDialog"
    top="10vh"
  >
    <div class="scroll-box">
      <p class="tx-18">
        <span>{{ $t("stockout.预计到货时间") }}:</span>
        <span>{{ dialogModal.row.timeExpectedArrival || "--" }}</span>
      </p>
      <el-radio-group v-model="isAgree">
        <el-radio :label="1">{{ $t("stockout.同意日期") }}</el-radio>
        <el-radio :label="2">{{ $t("stockout.不同意日期") }}</el-radio>
      </el-radio-group>
      <hr />
      <div v-if="isAgree == 2" class="d-flex align-items-center mg-b-15">
        <div class="mg-r-10">{{ $t("stockout.选择到货时间") }}:</div>
        <div>
          <el-date-picker
            v-model="newDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="remark-box">
        <div>{{ $t("stockout.备注") }}：</div>
        <div>
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="remark"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">
        {{ $t("stockout.确定") }}
      </el-button>
      <el-button @click="initDialog()">
        {{ $t("stockout.取消") }}
      </el-button>
    </div>
    <api-loading :show="loading"></api-loading>
  </el-dialog>
</template> 
<script>
export default {
  name: "name",
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          visible: false,
          row: {},
        };
      },
    },
  },
  data() {
    return {
      dialogModal: this.dialog,
      isAgree: 1,
      remark: "",
      loading: false,
      newDate: "",
    };
  },
  watch: {
    dialog: {
      handler: function () {},
      deep: true,
    },
  },
  methods: {
    initDialog() {
      this.dialog.visible = false;
      this.dialog.row = {};
    },
    save() {
      if (this.isAgree == 2 && this.remark === "") {
        ShowTip(this.$t("distributor.备注内容不能为空"), "danger");
        return;
      }
      if(this.isAgree == 2 && this.newDate == ""){
        ShowTip(this.$t("stockout.请选择到货时间"), "danger");
        return;
      }
      let parmas = {
        id: this.dialogModal.row.id,
        pass: this.isAgree,
        arrivalDate: this.dialogModal.row.timeExpectedArrival,
        remark: this.remark,
      };
      if(this.isAgree == 2){
        parmas.arrivalDate = this.newDate
      }
      this.loading = true;
      $.api_call("api.OutOfStockList.confirmBySupplier", parmas, (r) => {
        if (r.ErrorCode == "9999") {
          this.loading = false;
          ShowTip(this.$t("rm.操作成功"), "success");
          this.initDialog();
          this.$parent.getStockoutList();
        } else {
          this.loading = false;
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  border: 1px solid #eee;
  padding: 30px 50px;
}
.scroll-box {
  height: 300px;
  overflow-y: auto;
}
.remark-box {
  display: grid;
  grid-template-columns: 50px 1fr;
}
</style>

